import { Button, Grid } from "@mui/material";
import * as React from "react";
import BasicOrganizationData from "./BasicOrganizationData";
import OrganizationUsers from "./OrganizationUsers";
import OrganizationContract from "./OrganizationContract";
import OrganizationCommitmentUsage from "./OrganizationCommitmentUsage";
import OrganizationChannelSettings from "./OrganizationChannelSettings";
import { GetFullOrganizationDetails_organization } from "../../views/App/__generated__/GetFullOrganizationDetails";
import OrganizationTLA from "./OrganizationTLA";
import OrganizationQuotas from "./OrganizationQuotas";
import gql from "graphql-tag";
import { useMutation } from "react-apollo";
import {
    ConnectOrganizationToTHEOportal,
    ConnectOrganizationToTHEOportalVariables,
} from "./__generated__/ConnectOrganizationToTHEOportal";
import { toast } from "react-toastify";
import { GET_FULL_ORGANIZATION_DETAILS } from "../../views/App/ManageOrganization";
import AuthService from "../../auth/AuthService";

export const CONNECT_ORGANIZATION_TO_THEOPORTAL = gql`
    mutation ConnectOrganizationToTHEOportal($organizationId: ID!) {
        connectOrganizationToTHEOportal(organizationId: $organizationId) {
            organizationId
        }
    }
`;

interface Props {
    organization: GetFullOrganizationDetails_organization;
}

function OrganizationDetails({ organization }: Props) {
    const { organizationId, theoportalCompanyId } = organization;
    const [connected, setConnected] = React.useState<boolean>(typeof theoportalCompanyId === "string");

    const [connectOrganizationToPortal, { loading }] = useMutation<
        ConnectOrganizationToTHEOportal,
        ConnectOrganizationToTHEOportalVariables
    >(CONNECT_ORGANIZATION_TO_THEOPORTAL);

    async function onConnect(): Promise<void> {
        try {
            await connectOrganizationToPortal({
                variables: {
                    organizationId,
                },
                refetchQueries: [
                    {
                        query: GET_FULL_ORGANIZATION_DETAILS,
                        variables: {
                            organizationId,
                        },
                    },
                ],
            });
            toast.success("Organization connected");
            setConnected(true);
        } catch {
            toast.error("Something went wrong");
        }
    }

    const tempUserIdToBlock = ["auth0|5d6f7bae50336a0e1a748a2b", "auth0|5d3857f897da660c14c3a58b"];
    const userId = AuthService.getLocalUserProfile()?.auth0Id ?? "";
    return (
        <Grid container spacing={4}>
            {tempUserIdToBlock.includes(userId) && !connected && (
                <Grid item xs={12}>
                    <div className="flex flex-row w-full justify-between items-center px-4 py-4 rounded-md bg-[#fff9e7]">
                        <div>
                            This organization is not connected to the THEOplayer portal yet. This need to be done in
                            order to generate a license.
                        </div>
                        <div>
                            <Button variant="contained" color="primary" disabled={loading} onClick={onConnect}>
                                {loading ? "Connecting..." : "Connect"}
                            </Button>
                        </div>
                    </div>
                </Grid>
            )}
            <Grid item xs={12} md={5}>
                <BasicOrganizationData organization={organization} />
            </Grid>
            <Grid item xs={12} md={7}>
                <OrganizationContract organization={organization} />
            </Grid>
            <Grid item xs={12} md={6}>
                <OrganizationChannelSettings organization={organization} />
            </Grid>
            <Grid item xs={12} md={6}>
                <OrganizationQuotas organization={organization} />
            </Grid>
            <Grid item xs={12}>
                <OrganizationTLA organization={organization} />
            </Grid>
            <Grid item xs={12}>
                <OrganizationCommitmentUsage organization={organization} />
            </Grid>
            <Grid item xs={12}>
                <OrganizationUsers organizationId={organizationId} />
            </Grid>
        </Grid>
    );
}

export default OrganizationDetails;
